var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
function SvgPinObjectOutline34(_a, svgRef) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 34 40", xmlns: "http://www.w3.org/2000/svg", className: "YdsSvgIcon-root ".concat(className !== null && className !== void 0 ? className : ''), width: '2.125rem', height: '2.5rem', fill: "currentColor", focusable: "false", "aria-hidden": "true", ref: svgRef }, props),
        React.createElement("ellipse", { id: "tip", transform: "translate(14.5 36.75)", cx: 3, cy: 1.5, rx: 3, ry: 1.5, fill: "rgba(119,136,153,0.3)", opacity: 0 }),
        React.createElement("g", { id: "shape" },
            React.createElement("path", { id: "outline", transform: "translate(-599.11 -11111)", d: "M613.27 11143a15.5 15.5 0 1 1 5.679 0l-2.339 4.261z", fill: "#252c33" }),
            React.createElement("path", { id: "inner", transform: "translate(-1989 -9249)", d: "M2003.9 9279.8a14 14 0 1 1 4.21 0l-1.855 3.157z", fill: "#fff" }),
            React.createElement("circle", { id: "background", transform: "translate(4.25 4.25)", cx: 12.75, cy: 12.75, r: 12.75, fill: "currentColor" }),
            React.createElement("path", { id: "selection", transform: "translate(-599.11 -11110)", d: "m616.346 11143.812 1.8-3.089 1.061-.239a13.987 13.987 0 0 0 10.9-13.657 14 14 0 1 0-24.86 8.837 14.054 14.054 0 0 0 7.859 4.843l.909.2 2.33 3.107m.261 4.516-4.033-5.379a16.5 16.5 0 1 1 7.185-.026z", fill: "#106ecc", opacity: 0 }))));
}
var ForwardRef = React.forwardRef(SvgPinObjectOutline34);
export default ForwardRef;
